import httpClient from 'services/httpClient';

/**
 * In-app notifications API (`/notifications`).
 *
 * httpClient returns the response BODY already (the `{ success, message, data,
 * meta }` envelope) and injects the auth token — never add tokens/JSON manually.
 * Response shapes:
 *   list()        -> { success, data: [ …notification ], meta: { count } }
 *   unreadCount() -> { success, data: { unread_count } }
 *   markAllRead() -> { success, data: { updated } }
 */
export const notificationService = {
  // GET /notifications?unread_only=&limit=&offset=
  list: (params) => httpClient.get('/notifications', { params }),
  // GET /notifications/unread-count
  unreadCount: () => httpClient.get('/notifications/unread-count'),
  // POST /notifications/:id/read
  markRead: (id) => httpClient.post(`/notifications/${id}/read`),
  // POST /notifications/mark-all-read
  markAllRead: () => httpClient.post('/notifications/mark-all-read'),
  // DELETE /notifications/:id
  remove: (id) => httpClient.delete(`/notifications/${id}`),
  // POST /notifications/fcm-token — register this browser's web-push token.
  saveFcmToken: (token) => httpClient.post('/notifications/fcm-token', { token }),
};

export default notificationService;
